/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DiscriminatorTypeDto = {
    WithBasicPrice: 'WITH_BASIC_PRICE',
    WithConditionalPrices: 'WITH_CONDITIONAL_PRICES',
} as const;

export type DiscriminatorTypeDto = typeof DiscriminatorTypeDto[keyof typeof DiscriminatorTypeDto];



